<template>
  <div class="page-setting">
    <div class="page-setting__item">
      <div>手机号</div>
      <div class="val">{{ mobileNum }}</div>
    </div>
    <div class="page-setting__item" @click="copyText(userInfo.uuid)">
      <div>UUID</div>
      <div class="val">{{ userInfo.uuid }}</div>
    </div>

    <div
      v-if="!isMgtv && !isImgoEc"
      @click="hadleLoginOut"
      class="page-setting__btn"
    >
      退出登录
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ua from "@tp/ua";
import { logout } from "@utils/login";
import { Toast } from "vant";
import { setDurationStorage } from "@utils/storage";

export default {
  components: {},
  data() {
    return {
      autoPv: true,
      // 数管的上报
      reportData: {
        cntp: "mgcard_setting",
        lob: {},
      },
      // 是否芒果app
      isMgtv: ua.isImgo(),
      // 是否小芒
      isImgoEc: ua.isImgoEc(),
    };
  },

  computed: {
    ...mapState(["userInfo", "deviceInfo"]),
    mobileNum() {
      const reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/;
      return this.userInfo.mobile.replace(reg, "$1****$2");
    },
  },

  mounted() {
    console.log("isMgtv", this.isMgtv);
    console.log("isImgoEc", this.isImgoEc);
  },

  methods: {
    // 退出
    hadleLoginOut() {
      logout();
      this.$store.commit("setUserInfo", null);
      // 点击页面按钮跳登录
      setDurationStorage("needLogin", 1); // 已经触发登录跳转，点击页面按钮才跳转登录
      // 正式
      this.$router.back();
    },

    // 复制
    copyText(val) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly"); // 解决点击复制时，屏幕下方会出现白屏抖动问题
      input.setAttribute("value", val);
      document.body.appendChild(input);
      input.select();

      if (document.execCommand("copy")) {
        document.execCommand("copy");
        Toast("复制成功");
      } else {
        Toast("复制失败");
      }
      document.body.removeChild(input);
    },
  },
};
</script>

<style lang="less">
.page-setting {
  height: 100vh;
  background: #fff;
  &__item {
    height: 64px;
    padding: 0 15px;
    font-size: 16px;
    font-weight: 400;
    color: #29170a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .arrow-right {
      width: 24px;
      height: 24px;
    }
    .val {
      color: #655044;
      font-size: 14px;
    }
  }
  &__btn {
    background: #fff3e7;
    color: #ff6c14;
    height: 46px;
    margin: 0 15px;
    font-weight: bold;
    margin-top: 30px;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
